import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { useTranslation } from "react-i18next";

function Table({ rows, columns, testId }) {
  return (
    <div className="luxe-card overflow-x-auto" data-testid={testId}>
      <table className="w-full text-sm">
        <thead className="border-b border-[#D4AF37]/20">
          <tr className="text-left text-[10px] tracking-[0.22em] uppercase text-[#D4AF37]/80">
            {columns.map(c => <th key={c.key} className="px-4 py-3">{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={columns.length} className="px-4 py-10 text-center text-[#F8F5EF]/50">—</td></tr>}
          {rows.map(r => (
            <tr key={r.id} className="border-b border-[#D4AF37]/10 hover:bg-[#D4AF37]/5">
              {columns.map(c => <td key={c.key} className="px-4 py-3 align-top">{c.render ? c.render(r) : r[c.key]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function AdminEvents() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/events").then(r => setRows(r.data)); }, []);
  const cols = [
    { key: "date", label: "Date", render: r => r.date || "—" },
    { key: "name", label: "Nom" },
    { key: "event_type", label: "Type" },
    { key: "guests", label: "Pers." },
    { key: "phone", label: "Tel" },
    { key: "email", label: "Email" },
    { key: "message", label: "Détails", render: r => <span className="text-[#F8F5EF]/70">{r.message || "—"}</span> },
  ];
  return (
    <div className="p-8 lg:p-12" data-testid="admin-events-page">
      <div className="overline">Back-office</div>
      <h1 className="font-serif-luxe text-4xl text-[#F8F5EF] mt-2 mb-8">{t("admin.events")}</h1>
      <Table rows={rows} columns={cols} testId="admin-events-table" />
    </div>
  );
}

export function AdminContact() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/contact").then(r => setRows(r.data)); }, []);
  const cols = [
    { key: "created_at", label: "Date", render: r => (r.created_at || "").slice(0, 10) },
    { key: "name", label: "Nom" },
    { key: "email", label: "Email" },
    { key: "phone", label: "Tel" },
    { key: "subject", label: "Sujet" },
    { key: "message", label: "Message", render: r => <span className="text-[#F8F5EF]/70 max-w-md inline-block truncate align-bottom">{r.message}</span> },
  ];
  return (
    <div className="p-8 lg:p-12" data-testid="admin-contact-page">
      <div className="overline">Back-office</div>
      <h1 className="font-serif-luxe text-4xl text-[#F8F5EF] mt-2 mb-8">{t("admin.contact")}</h1>
      <Table rows={rows} columns={cols} testId="admin-contact-table" />
    </div>
  );
}
